import { DataSourceSetupComposite } from "./DataSourceSetupComposite";

export const NamelySetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      showInputControls
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
    />
  );
};
